import { useContext, useEffect, useState } from 'react'
import { AnalyticsContext } from './useAnalytics'

const ONE_TRUST_TIMEOUT_MS = 5000

export function useOptimizelyObfuscation(aboveFoldExperimentation?: boolean) {
  const [hidden, setHidden] = useState(aboveFoldExperimentation)
  const { optimizelyConfigured } = useContext(AnalyticsContext)

  useEffect(() => {
    setHidden(
      !document.cookie.match('OptanonAlertBoxClosed') &&
        aboveFoldExperimentation,
    )
  }, [aboveFoldExperimentation])

  useEffect(() => {
    if (!aboveFoldExperimentation) return

    const timeout = window.setTimeout(() => {
      const oneTrustBanner = document.getElementById('onetrust-banner-sdk')
      const oneTrustGroupsAvailable =
        typeof window.OnetrustActiveGroups === 'string'
      if (oneTrustBanner || oneTrustGroupsAvailable) return

      setHidden(false)
    }, ONE_TRUST_TIMEOUT_MS)

    return () => window.clearTimeout(timeout)
  }, [aboveFoldExperimentation])

  return { hidden, optimizelyConfigured }
}
